import { render, staticRenderFns } from "./EditEmailLog.vue?vue&type=template&id=21ee3974"
import script from "./EditEmailLog.vue?vue&type=script&lang=js"
export * from "./EditEmailLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditEmailLog.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ee3974')) {
      api.createRecord('21ee3974', component.options)
    } else {
      api.reload('21ee3974', component.options)
    }
    module.hot.accept("./EditEmailLog.vue?vue&type=template&id=21ee3974", function () {
      api.rerender('21ee3974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditEmailLog.vue"
export default component.exports